import UiHelper from './UiHelper';
import { Form } from './Form';


class NewsletterForms
{
    static init()
    {
        this.instances = [];

        // bind functions
        this.refresh = this.refresh.bind(this);

        const forms = UiHelper.getNodes('.js-newsletter-form');

        if (forms.length)
        {
            Array.from(forms).forEach(form => this.initForm(form));

            UiHelper.registerHandler('resize', this.refresh, 'throttle');
            this.refresh();
        }
    }

    static initForm(form)
    {
        this.register(new NewsletterForm(form));
    }

    static register(newsletterForm)
    {
        this.instances.push(newsletterForm);
    }

    static refresh()
    {
        this.instances.forEach(newsletterForm =>
        {
            newsletterForm.refreshDisplay();
        });
    }

}
export default NewsletterForms;

class NewsletterForm
{
    constructor(form)
    {
        //this.handleResponse = this.handleResponse.bind(this);

        this.form = form;
        this.inputWraps = Array.from(form.querySelectorAll('.js-newsletter-form__input-wrap'));

        // new Form(this.form, {
        //     loadingClass: 'newsletter-form--loading',
        //     handleResponse: this.handleResponse
        // });
    }

        // static handleResponse(response)
        // {
        //     this.form.classList.remove('newsletter-form--loading');
        //
        //     if (response.success)
        //     {
        //         this.feedbackMsg.classList.add('comment-form__feedback-msg--success');
        //         this.form.reset();
        //         this.form.classList.remove('comment-form--replying');
        //     }
        //     else
        //     {
        //         this.feedbackMsg.classList.add('comment-form__feedback-msg--error');
        //     }
        //
        //     this.feedbackMsg.innerHTML = `<p>${response.message}</p><button class="btn btn--sm theme-bgclr-1-before" type="button">${window.labels.close}</button>`;
        //
        //     this.form.classList.add('comment-form--feedback');
        // }

    refreshDisplay()
    {
        const action = this.form.offsetWidth >= 540 ? 'add' : 'remove';
        this.inputWraps.forEach(inputWrap =>
        {
            inputWrap.classList[action]('form__input-wrap--inline');
        });
    }
}
